import * as React from "react";
import { Button } from "@grandvisionhq/common";
import { RichBanner } from "@grandvisionhq/content";
import { Form, FirstName, MiddleName, LastName, Email, CheckboxList } from "@grandvisionhq/forms";
import { useIntl } from "@grandvisionhq/state";
/* empty css                        */
const getItemIdentifier = (item) => item.value;
const getItemErrorMessage = (item) => item?.errorMessage || "";
const RichBannerCampaign = ({
  onSubmit,
  onChange,
  formState,
  optIns,
  selectedOptIns,
  setSelectedOptIns,
  consents,
  selectedConsents,
  setSelectedConsents,
  isLoading,
  ...props
}) => {
  const { getLabel, getFormattedLabel } = useIntl();
  return /* @__PURE__ */ React.createElement(RichBanner, { ...props }, /* @__PURE__ */ React.createElement(
    Form,
    {
      onSubmit,
      name: "campaign",
      "data-t": "campaign-form",
      initialFormState: formState,
      onChange
    },
    /* @__PURE__ */ React.createElement("div", { className: "campaign-form" }, /* @__PURE__ */ React.createElement(
      FirstName,
      {
        required: true,
        label: getLabel("checkout.contact.firstName"),
        errorMessage: getLabel("checkout.contact.firstName.errorMessage")
      }
    ), /* @__PURE__ */ React.createElement(
      MiddleName,
      {
        required: true,
        label: getLabel("checkout.contact.middleName"),
        errorMessage: getLabel("checkout.contact.middleName.errorMessage")
      }
    ), /* @__PURE__ */ React.createElement(
      LastName,
      {
        required: true,
        label: getLabel("checkout.contact.lastName"),
        errorMessage: getLabel("checkout.contact.lastName.errorMessage")
      }
    ), /* @__PURE__ */ React.createElement(
      Email,
      {
        label: getLabel("fields.input.email.label"),
        errorMessage: getLabel("account.error.emailInvalid"),
        required: true
      }
    )),
    !!optIns && !!optIns.length && /* @__PURE__ */ React.createElement(
      CheckboxList,
      {
        idPrefix: "opt-in__",
        items: optIns,
        onChange: setSelectedOptIns,
        selectedItems: selectedOptIns,
        getItemIdentifier: (optIn) => optIn.titleKey,
        renderItem: (item) => /* @__PURE__ */ React.createElement("span", null, getFormattedLabel(item.titleKey, { parseHTML: true }))
      }
    ),
    /* @__PURE__ */ React.createElement(
      CheckboxList,
      {
        getItemIdentifier,
        getItemErrorMessage,
        idPrefix: "consents__",
        items: consents,
        onChange: setSelectedConsents,
        renderItem: (item) => getFormattedLabel(item.titleKey),
        selectedItems: selectedConsents
      }
    ),
    /* @__PURE__ */ React.createElement(
      Button,
      {
        "data-t": "submit-signup-campaign",
        type: "submit",
        isLoading,
        caption: getLabel("campaign.signup.submit"),
        className: "login__button"
      }
    )
  ));
};
export {
  RichBannerCampaign
};
//# sourceMappingURL=RichBannerCampaign.js.map
